import ApiInstance from 'utils/instances';

export const getUserInfo = async (token: string): Promise<any> => {
  return await ApiInstance.get(`/user/details`, {
    headers: {
      'x-tifin-ai-auth': token,
    },
  }).then(res => res.data);
};
